import { useAuth } from "@/lib/auth";
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useBusinessSlugCheck = () => {
  const { user } = useAuth();

  const { data: businessSlugData, isLoading, error } = useQuery({
    queryKey: ['business-slug-check', user?.id],
    queryFn: async () => {
      if (!user) return null;
      
      const { data, error } = await supabase
        .from('profiles')
        .select('business_slug')
        .eq('id', user.id)
        .maybeSingle();

      if (error) throw error;
      return data?.business_slug || null;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  // Memoized return value to prevent unnecessary re-renders
  const result = useMemo(() => {
    // Check if business_slug exists and is not empty
    const hasBusinessSlug = !!(businessSlugData && businessSlugData.trim() !== '');
    
    return { 
      hasBusinessSlug, 
      loading: isLoading 
    };
  }, [businessSlugData, isLoading]);

  return result;
}; 